<template>
    <div class="w100 h100">
        <router-view />
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { CREATE_SESSION } from './store/actions.type.js'
export default {
    data() {
        return {
            accountData: {
                email: 'public@public',
                password: 'public',
            },
        }
    },

    methods: {
        ...mapActions({
            CREATE_SESSION,
        }),
    },

    async created() {
        await this.CREATE_SESSION(this.accountData)
    },
}
</script>
